import { FormInputText } from 'camino-react'
import { isEmpty, isNil } from 'lodash'
import React, { Fragment } from 'react'

const TicketFormContactMethodFields = ({
  currentUser,
  setFieldErrorClasses,
  setFieldValue,
  preferred_contact_method,
  contact_number,
  primaryContactEmail
}) => {
  const mobilePhoneNumber = isNil(currentUser.phone_number) ? 'No number saved' : currentUser.phone_number
  const contactEmail = (isEmpty(primaryContactEmail) || isNil(primaryContactEmail)) ? `: ${currentUser.email_address}` : primaryContactEmail

  return (
    <Fragment>
      <label htmlFor="ticket_preferred_contact_method_email" className="label" style={{ marginBottom: '15px' }}>
        <input
          value="email"
          name="preferred_contact_method"
          id="ticket_preferred_contact_method_email"
          type="radio"
          className={setFieldErrorClasses('preferred_contact_method')}
          onChange={value => setFieldValue('preferred_contact_method', 'email')}
        />
        <span />
        Email
        {' '}
        {!currentUser.isGuestUser && contactEmail}
      </label>

      <label htmlFor="ticket_preferred_contact_method_phone" className="label" style={{ marginBottom: '15px' }}>
        <input
          value="phone"
          name="preferred_contact_method"
          id="ticket_preferred_contact_method_phone"
          type="radio"
          className={setFieldErrorClasses('preferred_contact_method')}
          onChange={value => setFieldValue('preferred_contact_method', 'phone')}
        />
        <span />
        Phone
        {' '}
        {!currentUser.isGuestUser && `: ${mobilePhoneNumber}`}
      </label>

      {preferred_contact_method == 'phone' && isNil(currentUser.phone_number) && (
        <label htmlFor="ticket_contact_number" style={{ marginBottom: '20px' }}>
          Phone Number
          <FormInputText
            value={contact_number}
            className={setFieldErrorClasses('contact_number')}
            onValue={value => setFieldValue('contact_number', value)}
          />
        </label>
      )}
    </Fragment>
  )
}

export default TicketFormContactMethodFields
